import './components/calculators/format';
import './components/calculators/finance';
import './components/calculators/calculator-products';
import './components/calculators/mortgage';
import './components/calculators/input';
import './components/calculators/products';

// =====================================================================
//  DEBT CONSOLIDATION — interactivity layer (no HTML strings)
//  All markup lives in debt-consolidation.html. This file:
//    1. Reads inputs (debt rows, profile, new loan amount)
//    2. Recomputes totals + per-bank offers
//    3. Updates specific DOM targets and toggles bank-card visibility
// =====================================================================
(function () {
  const fmt = Calc.format;
  const fin = Calc.finance;

  const state = {
    sort: { key: 'best', dir: 'desc' },   // template's selected option sets the default
    debts: [
      { id: 'cc', type: 'credit_card', label: 'Credit Card',
        outstanding: 100000, instalment: 5000, autoCalc: true },
      { id: 'pl', type: 'personal_loan', label: 'Personal Loan',
        outstanding: 100000, instalment: 2000,
        rateType: 'flat', rate: 0.0788, autoCalc: false },
    ],
    newLoanAmount: 200000,
    profile: { incomeType: 'salaried', income: 5000, age: 30 },
  };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => root.querySelectorAll(sel);
  const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
  // Write a value into a placeholder span (text is in HTML, JS only writes the value).
  const setVal = (sel, val, root) => {
    const el = (root || document).querySelector(sel);
    if (el) el.textContent = val;
  };
  // Escape dynamic strings before injecting as HTML (bank names / reason text
  // originate from the external product feed).
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  // -------------------------------------------------------------------
  //  Stat band + totals
  // -------------------------------------------------------------------
  function updateStatBand() {
    const totalOut = fin.totalOutstanding(state.debts);
    const totalMonthly = fin.totalMonthly(state.debts);
    const dsr = state.profile.income ? totalMonthly / state.profile.income : 0;

    setText('dc-stat-debt',    fmt.money(totalOut, 0));
    setText('dc-stat-monthly', fmt.money(totalMonthly, 0));
    const dsrHasValue = state.profile.income > 0;
    setVal('.dc-stat-dsr-num', dsrHasValue ? (dsr * 100).toFixed(0) : '');
    document.querySelector('.dc-stat-dsr-num').classList.toggle('d-none', !dsrHasValue);
    document.querySelector('.dc-stat-dsr-pct').classList.toggle('d-none', !dsrHasValue);
    document.querySelector('.dc-stat-dsr-empty').classList.toggle('d-none', dsrHasValue);

    setText('total-outstanding', fmt.money(totalOut));
    setText('total-instalment',  fmt.money(totalMonthly));
  }

  // -------------------------------------------------------------------
  //  Compute eligible offers, keyed by bank id
  // -------------------------------------------------------------------
  function buildOffers() {
    const loanAmt = state.newLoanAmount;
    const existingMonthly = fin.totalMonthly(state.debts);
    const out = {};
    // Guard against malformed feed data: getCalculatorProducts()/json_encode
    // can hand us a non-array (object or null) when the upstream list is empty
    // or keyed oddly. Treat anything that isn't an array as "no lenders".
    const lenders = Array.isArray(Calc.data?.debtConsolidation) ? Calc.data.debtConsolidation : [];
    lenders.forEach(bank => {
      const elig = Calc.eligibility.check(bank, state.profile, loanAmt, 0);
      const o = { bank, eligible: elig.eligible, reasons: elig.reasons };
      if (elig.eligible) {
        o.calc = bank.rateType === 'flat'
          ? fin.flatRate(loanAmt, bank.interestRate / 100, bank.maxTenure)
          : fin.reducingRate(loanAmt, bank.interestRate / 100, bank.maxTenure);
        o.save = existingMonthly - o.calc.monthlyInstalment;
      }
      out[bank.prod_id] = o;
    });
    return out;
  }

  // -------------------------------------------------------------------
  //  Savings card — toggle empty/active, update text + progress widths
  // -------------------------------------------------------------------
  function updateSavings(offers) {
    const card = document.getElementById('dc-savings-card');
    const empty = document.getElementById('dc-savings-empty');
    const existingMonthly = fin.totalMonthly(state.debts);

    const eligibleSorted = Object.values(offers).filter(o => o.eligible).sort((a, b) => b.save - a.save);
    if (eligibleSorted.length === 0 || existingMonthly === 0) {
      card.classList.add('d-none');
      empty.classList.remove('d-none');
      return;
    }
    const best = eligibleSorted[0];
    const save = best.save;
    const savePct = existingMonthly > 0 ? (save / existingMonthly) * 100 : 0;
    const max = Math.max(existingMonthly, best.calc.monthlyInstalment);
    const beforePct = (existingMonthly / max) * 100;
    const afterPct = (best.calc.monthlyInstalment / max) * 100;
    const isPositive = save >= 0;

    empty.classList.add('d-none');
    card.classList.remove('d-none');

    document.getElementById('dc-savings-headline').classList.toggle('neg', !isPositive);
    $('.dc-savings-label-pos').classList.toggle('d-none', !isPositive);
    $('.dc-savings-label-neg').classList.toggle('d-none', isPositive);
    setText('dc-savings-amount', fmt.money(Math.abs(save), 0));

    const bankBtn = document.getElementById('dc-savings-bankname');
    if (bankBtn) bankBtn.textContent = best.bank.name;

    const pct = document.getElementById('dc-savings-pct');
    pct.classList.toggle('d-none', !isPositive);
    setVal('.dc-savings-pct-num', savePct.toFixed(0));

    document.getElementById('dc-bar-now').style.width = beforePct + '%';
    const afterBar = document.getElementById('dc-bar-after');
    afterBar.style.width = afterPct + '%';
    afterBar.classList.toggle('bg-success', isPositive);
    afterBar.classList.toggle('bg-danger', !isPositive);

    setVal('.dc-monthly-now-amount', fmt.money(existingMonthly, 0));
    const monAfter = document.getElementById('dc-monthly-after');
    setVal('.dc-monthly-after-amount', fmt.money(best.calc.monthlyInstalment, 0));
    monAfter.classList.toggle('text-success', isPositive);
    monAfter.classList.toggle('text-danger', !isPositive);
  }

  // -------------------------------------------------------------------
  //  Bank grid — toggle each card via .d-none + update values + sort via CSS order
  // -------------------------------------------------------------------
  function updateBankGrid(offers) {
    const wraps = $$('.bank-card-wrap');
    const emptyState = $('#bank-grid .bank-empty-state');
    let eligibleCount = 0;
    const ineligibleReasons = [];

    const eligibleAll = Object.values(offers).filter(o => o.eligible);
    const bestSorted = eligibleAll.slice().sort((a, b) => b.save - a.save);
    const bestId = (bestSorted.length && bestSorted[0].save > 0) ? bestSorted[0].bank.prod_id : null;
    const eligibleSorted = Calc.products.rank(
      eligibleAll.map((o, i) => ({ offer: o, index: i, name: o.bank.name, metrics: { best: o.save, rate: o.bank.interestRate } })),
      state.sort.key, state.sort.dir
    ).map(e => e.offer);

    Object.values(offers).forEach(o => {
      if (!o.eligible) {
        // Check if the function exists before calling it
        const rendered = (typeof Calc.eligibility.renderReasons === 'function')
          ? Calc.eligibility.renderReasons(o.reasons)
          : o.reasons; // Fallback to raw reasons if helper is missing
        ineligibleReasons.push(`<strong>${esc(o.bank.name)}:</strong> ${esc(Array.isArray(rendered) ? rendered.join('; ') : rendered)}`);
      }
    });

    // Keyed on the element, not the id: feed prod_id is a STRING while dataset
    // reads coerce to a number, and `===` between them silently never matched.
    const wrapOf = new Map();
    wraps.forEach(wrap => {
      const rawId = wrap.dataset.bankId;
      const offer = offers[rawId];
      if (!offer || !offer.eligible) {
        wrap.classList.add('d-none');
        return;
      }
      eligibleCount++;
      wrap.classList.remove('d-none');
      wrapOf.set(String(rawId), wrap);

      const logo = wrap.querySelector('.bank-logo');
      if (logo && offer.bank.image_url && logo.src !== offer.bank.image_url) {
        logo.src = offer.bank.image_url;
        logo.alt = offer.bank.name;
      }
      wrap.querySelector('.bank-monthly').textContent = fmt.money(offer.calc.monthlyInstalment, 0);
      wrap.querySelector('.bank-total').textContent = fmt.money(offer.calc.totalRepayment, 0);

      const isPositive = offer.save >= 0;
      const strip = wrap.querySelector('.bank-save-strip');
      strip.classList.toggle('is-negative', !isPositive);
      const lblPos = wrap.querySelector('.bank-save-label-pos');
      const lblNeg = wrap.querySelector('.bank-save-label-neg');
      lblPos.classList.toggle('d-none', !isPositive);
      lblNeg.classList.toggle('d-none', isPositive);
      [lblPos, lblNeg].forEach(el => {
        el.classList.toggle('text-primary', isPositive);
        el.classList.toggle('text-danger', !isPositive);
      });
      const val = wrap.querySelector('.bank-save-value');
      val.textContent = fmt.money(Math.abs(offer.save), 0);
      val.classList.toggle('text-primary', isPositive);
      val.classList.toggle('text-danger', !isPositive);

    });

    Calc.products.applyOrder(
      wraps,
      eligibleSorted.map(o => ({ wrap: wrapOf.get(String(o.bank.prod_id)) })).filter(e => e.wrap),
      bestId != null ? wrapOf.get(String(bestId)) : null
    );

    emptyState.classList.toggle('d-none', eligibleCount > 0);
    // Empty state always sorts to the end
    emptyState.style.order = wraps.length;

    const note = document.getElementById('ineligible-note');
    const reasonsEl = document.getElementById('ineligible-reasons');
    if (ineligibleReasons.length) {
      note.classList.remove('d-none');
      reasonsEl.innerHTML = ineligibleReasons.join('\n');
    } else {
      note.classList.add('d-none');
    }
  }

  // -------------------------------------------------------------------
  //  Debt row inputs — update existing total cells
  // -------------------------------------------------------------------
  function syncDebtRow(row, debt) {
    const out = row.querySelector('.d-out');
    const mon = row.querySelector('.d-inst');
    Calc.input.syncValue(out, debt.outstanding);
    // d-inst is money-masked (no decimals shown) — pass integer string.
    Calc.input.syncValue(mon, (+debt.instalment).toFixed(0));
    if (mon) mon.readOnly = !!debt.autoCalc;
  }

  // -------------------------------------------------------------------
  //  Refresh
  // -------------------------------------------------------------------
  function refresh() {
    updateStatBand();
    const offers = buildOffers();
    updateSavings(offers);
    updateBankGrid(offers);
  }

  // -------------------------------------------------------------------
  //  Events
  // -------------------------------------------------------------------
  function bindEvents() {
    document.addEventListener('input', (e) => {
      const t = e.target;
      const v = Calc.input.getValue(t);
      if (t.classList.contains('d-out')) {
        const idx = +t.closest('tr').dataset.idx;
        state.debts[idx].outstanding = v || 0;
        if (state.debts[idx].autoCalc) {
          state.debts[idx].instalment = fin.creditCardMinimum(state.debts[idx].outstanding);
          syncDebtRow(t.closest('tr'), state.debts[idx]);
        }
        refresh();
      }
      if (t.classList.contains('d-inst')) {
        const idx = +t.closest('tr').dataset.idx;
        state.debts[idx].instalment = v || 0;
        refresh();
      }
      if (t.id === 'new-loan-amount') { state.newLoanAmount = v || 0;   refresh(); }
      if (t.id === 'monthly-income')  { state.profile.income = v || 0;  refresh(); }
      if (t.id === 'age')             { state.profile.age = v || 0;     refresh(); }
    });

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t.classList.contains('d-auto')) {
        const row = t.closest('tr');
        const idx = +row.dataset.idx;
        state.debts[idx].autoCalc = t.checked;
        if (t.checked) state.debts[idx].instalment = fin.creditCardMinimum(state.debts[idx].outstanding);
        syncDebtRow(row, state.debts[idx]);
        refresh();
      }
      if (t.classList.contains('d-ratetype')) {
        const idx = +t.closest('tr').dataset.idx;
        state.debts[idx].rateType = t.value;
        state.debts[idx].rate = t.value === 'flat' ? 0.0788 : 0.1323;
        refresh();
      }
      if (t.id === 'income-type') { state.profile.incomeType = t.value; refresh(); }
    });

    document.addEventListener('click', (e) => {
      if (e.target.id === 'match-total') {
        state.newLoanAmount = fin.totalOutstanding(state.debts);
        document.getElementById('new-loan-amount').value = state.newLoanAmount;
        refresh();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    const initialSort = Calc.products.bindSort('#dc-sort-select', (sort) => {
      state.sort = sort;
      refresh();
    });
    if (initialSort) state.sort = initialSort;
    refresh();
  });
})();